// extracted by extract-css-chunks-webpack-plugin
module.exports = {"dialog":"_1fEQe","mobile":"_17amD"};